<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList" (onRowSelect)="onRowSelect($event)">
    <ng-template pTemplate="caption">
        {{title}}
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn] = "col.field" id ="{{col.header}}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <ng-container *ngFor="let col of columns" >
              <td *ngIf="col.field!=isActive && col.field!=isQcPrimer">
                  {{rowData[col.field]}}
              </td>
              <td *ngIf="col.field==isActive || col.field==isQcPrimer">
                  <p-checkbox id="printEnabled" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary" let-rowData>
        <div style="text-align:left">
            <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" class="h-2rem" label="Add"></button>
        </div>
      </ng-template>
</p-table>

<p-dialog header="{{popupTitle}} Details" position="top" [(visible)]="displayMasterListDialog"  showEffect="fade" [modal]="true"
[style]="{'width':'400px'}">
    <div *ngIf="masterList">
        <div *ngFor="let col of tableCols">
            <div class="form-group m-2">
              <label>{{col.header}}</label>
              <div *ngIf ="col.field==isPrimerName">
                <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" required="required" (blur)="masterList[col.field]=removeSpaces(masterList[col.field])"  oninput="this.value = this.value.replace(/[^a-zA-Z0-9_-. ]/, '')">
              </div>
              <div *ngIf ="col.field==isSequence">
                <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" (change)="masterList[col.field]=removeSpaces(masterList[col.field])" oninput="this.value = this.value.replace(/[^a-zA-Z0-9_-. ]/, '')">                    
              </div>
              <div *ngIf ="col.field==isPrimerID ">
                  <input type="number" step="0.1" pInputText class="form-control" [(ngModel)]="masterList[col.field]" (change)="masterList[col.field]=masterLis[col.field].trim()" pattern="^\d*(\.\d{0,0})?$">                      
              </div>
              <div *ngIf ="col.field==isGC || col.field==isTM">
                <input type="number" step="0.1" pInputText class="form-control" [(ngModel)]="masterList[col.field]" (change)="masterList[col.field]=masterLis[col.field].trim()" pattern="^\d*(\.\d{0,1})?$">                    
              </div>
              <div *ngIf ="col.field==isActive || col.field==isQcPrimer">
                <p-checkbox [(ngModel)]="masterList[col.field]" binary="true" ></p-checkbox>
              </div>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button type="button" class="h-2rem" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()" label="Save"></button>
        </div>
    </p-footer>
  </p-dialog>